import Store from 'lightningjs-redux';
import { getCurrentLayout } from '../../logic/layout/layout.selectors';

import {
  getCanPlay,
  getPlaybackState,
  getIsEnded,
  getSideGlassContent,
  getAudioTracks,
  getSubtitleTracks,
  isAdMode,
  getPauseAdState,
  getLBannerState,
  isPlayerLoading,
} from '../../logic/player/player.selectors';
import { getCurrentVideoItem, isVideoEnding } from '../../logic/player/video.selectors';

const mapControllers = instance => ({
  layout: {
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: () => {
      instance.start();
    },
  },
  canPlay: {
    selector: getCanPlay,
    callback: value => {
      instance.canPlay = value;
    },
  },
  playbackState: {
    selector: getPlaybackState,
    callback: value => {
      instance.playbackState = value;
    },
  },
  isLoading: {
    selector: isPlayerLoading,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.isLoading = value;
    },
  },
  isAdBreakDisplayed: {
    selector: isAdMode,
    callback: value => {
      instance.isAdBreakDisplayed = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  sideGlass: {
    selector: getSideGlassContent,
    callback: value => {
      instance.hasRelatedVideos = value;
    },
  },
  audioTracks: {
    selector: getAudioTracks,
    callback: value => {
      instance.audioTracks = value;
    },
  },
  subtitleTracks: {
    selector: getSubtitleTracks,
    callback: value => {
      instance.subtitleTracks = value;
    },
  },
  nextVideo: {
    selector: getIsEnded,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.shouldDisplayNextVideo = value;
    },
  },
  programInformation: {
    selector: getCurrentVideoItem,
    callback: value => {
      instance.programInformation = value;
    },
  },
  isVideoEnding: {
    selector: isVideoEnding,
    callback: value => {
      instance.isVideoEnding = value;
    },
  },
  pauseAdState: {
    selector: getPauseAdState,
    callback: value => {
      instance.pauseAdState = value;
    },
  },
  shouldDisplayLBanner: {
    selector: getLBannerState,
    callback: value => {
      instance.shouldDisplayLBanner = value;
    },
  },
});

export default Store.control(mapControllers);
